import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { connectAuthEmulator } from "firebase/auth";
import { getStorage } from "firebase/storage";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAafShH6Zm0qomVn60bGW9p-PTnesn4lJU",
  authDomain: "mastery-method.firebaseapp.com",
  projectId: "mastery-method",
  storageBucket: "mastery-method.firebasestorage.app",
  messagingSenderId: "644792107684",
  appId: "1:644792107684:web:393eacc880b6ec1b5edc31",
  measurementId: "G-QPRFGGFZ5C",
};

// Initialize Firebase only if it hasn't been initialized already
let app;
if (!getApps().length) {
  app = initializeApp(firebaseConfig);
} else {
  app = getApps()[0];
}

if (window.location.hostname.includes("csb.app")) {
  console.log("Running in CodeSandbox - setting up auth");
}

// Get Auth and Firestore instances
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;
